import React, { useState, useEffect } from "react";
import { Menu, X, Anchor, ChevronsRight } from "lucide-react";
import { useCruise } from "../context/CruiseContext";
import { Button } from "./ui/button";
import CruiseSwitch from "./CruiseSwitch";

const Navbar = () => {
  const { NAV_LINKS, EVENT, logo, logoAlt } = useCruise();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed top-0 left-0 w-full z-50">
      {/* Dedicated cruise-choice strip */}
      <div className="w-full bg-black border-b border-white/10">
        <div className="max-w-7xl mx-auto px-5 min-h-[44px] py-1.5 flex items-center justify-center sm:justify-between gap-3">
          <span
            data-testid="voyage-choose-label"
            className="hidden sm:flex items-center gap-2.5 text-white font-cond font-bold uppercase tracking-[0.28em] text-base lg:text-lg"
          >
            <Anchor size={19} className="text-[#E50914]" />
            <span>
              Choose Your <span className="text-[#E50914]">HHAS Voyage</span>
            </span>
            <ChevronsRight size={22} className="text-white animate-pulse" />
          </span>
          <CruiseSwitch />
        </div>
      </div>

      {/* Main nav row */}
      <div
        className={`w-full transition-all duration-300 ${
          scrolled ? "bg-[#0A0A0A]/95 backdrop-blur-md border-b border-white/10 py-3" : "bg-transparent py-5"
        }`}
      >
        <div className="max-w-7xl mx-auto px-5 flex items-center justify-between">
          <a href="#home" className="flex items-center group py-1 pr-6 lg:mr-4">
            <img
              src={logo}
              alt={logoAlt}
              className={`w-auto object-contain transition-all duration-300 ${scrolled ? "h-12" : "h-16"}`}
            />
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV_LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                className="font-cond uppercase text-sm tracking-widest text-white/80 hover:text-[#E50914] transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-4">
            <a href={EVENT.bookingUrl} target="_blank" rel="noopener noreferrer">
              <Button className="bg-[#E50914] hover:bg-[#c20710] text-white font-cond uppercase tracking-widest rounded-full px-6">
                Book Now
              </Button>
            </a>
          </div>

          <button className="lg:hidden text-white" onClick={() => setOpen(!open)} aria-label="menu">
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0A0A0A] backdrop-blur-md border-t border-white/10">
          <div className="flex flex-col px-5 py-4 gap-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="font-cond uppercase text-sm tracking-widest text-white/80 hover:text-[#E50914]"
              >
                {l.label}
              </a>
            ))}
            <a href={EVENT.bookingUrl} target="_blank" rel="noopener noreferrer">
              <Button className="w-full bg-[#E50914] hover:bg-[#c20710] text-white font-cond uppercase tracking-widest rounded-full">
                Book Now
              </Button>
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
